import React from "react";
import ReusableModal from "../../../components/common/ReusableModal";
import FormButton from "../../../components/form/FormButton";

const value = (v) => (v === null || v === undefined || v === "" ? "—" : v);

const formatDateTime = (v) => {
  if (!v) return "—";

  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "—";

  return d.toLocaleString();
};

const LocalGameChatModal = ({
  open,
  data,
  loading = false,
  toggling = false,
  onToggleChat,
  onClose,
}) => {
  const items = Array.isArray(data?.items) ? data.items : [];
  const game = data?.meta?.game || {};

  const toggleTarget = {
    _id: game._id || data?.meta?.chatRoomId,
    gameCode: game.gameCode,
    sportName: game.sportName,
    chatEnabled: game.chatEnabled === true,
  };

  return (
    <ReusableModal
      open={open}
      title="Local Game Chat"
      onClose={onClose}
      width="860px"
      closeOnBackdrop={false}
      className="local-game-chat-modal"
    >
      {loading ? (
        <div className="sa-placeholder" style={{ height: 160 }}>
          Loading chat messages…
        </div>
      ) : !data ? (
        <div className="sa-empty">No chat data found.</div>
      ) : (
        <div className="lg-chat">
          <section className="lg-chat-summary">
            <div>
              <span>Game</span>
              <strong>{value(game.gameCode)}</strong>
            </div>

            <div>
              <span>Sport</span>
              <strong>{value(game.sportName)}</strong>
            </div>

            <div>
              <span>Venue</span>
              <strong>{value(game.venueName)}</strong>
            </div>

            <div>
              <span>Status</span>
              <strong>{value(game.status)}</strong>
            </div>

            <div className="lg-chat-control-card">
              <span>Game Chat</span>

              <div className="sa-status-wrap lg-chat-status-inline">
                <label className="sa-switch" title="Toggle chat status">
                  <input
                    type="checkbox"
                    checked={!!game.chatEnabled}
                    onChange={() => onToggleChat?.(toggleTarget)}
                    disabled={toggling || !toggleTarget._id}
                  />
                  <span />
                </label>

                <span className={`sa-status ${game.chatEnabled ? "active" : "inactive"}`}>
                  {game.chatEnabled ? "Enabled" : "Disabled"}
                </span>
              </div>
            </div>

            <div className="lg-chat-summary-wide">
              <span>Messages Path</span>
              <strong>{value(data?.meta?.messagesPath)}</strong>
            </div>
          </section>

          <section className="lg-chat-list-wrap">
            {items.length === 0 ? (
              <div className="sa-empty">No chat messages found.</div>
            ) : (
              <div className="lg-chat-list">
                {items.map((msg) => (
                  <div className="lg-chat-message" key={msg._id}>
                    <div className="lg-chat-message-head">
                      <strong>{value(msg.senderName)}</strong>
                      <small>{formatDateTime(msg.createdAt)}</small>
                    </div>

                    <p>{value(msg.message)}</p>

                    <div className="lg-chat-message-foot">
                      <span>Sender ID: {value(msg.senderId)}</span>
                      <span>Type: {value(msg.type)}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </section>

          <div className="lg-detail-actions">
            <FormButton type="button" variant="secondary" onClick={onClose}>
              Close
            </FormButton>
          </div>
        </div>
      )}
    </ReusableModal>
  );
};

export default LocalGameChatModal;